import {
	createResource,
	type RouteResource,
	type RouteResourceResponse,
} from 'react-resource-router';

import type { ContactsResponse } from '../../common/types';
import { getContacts } from '../endpoints';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

export const createContactsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
): RouteResource<ContactsResponse | null> =>
	createResource({
		type: 'contactsResource',
		getKey: () => 'contactsResource',
		getData: async ({ dependencies, match }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}
			const data = await getContacts(match.params?.targetAccountId);
			return data.contacts;
		},
		isBrowserOnly: true,
		depends,
	});

// Only meant to be used in platform
export const contactsResource: RouteResource<ContactsResponse | null> = createContactsResource();
